<div
    [id]="id + '.' + filter.id"
    class="agpr-filterAutocomplete"
>
    <agpr-filter-include-exclude
        *ngIf="filter.showIncludeExclude"
        [(ngModel)]="filter.currentIncludeExclude"
        (ngModelChange)="currentIncludeExcludeChange()"
    ></agpr-filter-include-exclude>
    <label
        class="agpr-filterAutocomplete-search"
    >
        <agpr-autocomplete
            [id]="id + '.' + filter.id + '.search'"
            labelField="label"
            [suggestionsFetcher]="filter.autocompleteOptions.bind(this)"
            [ngModel]="value"
            [valueForSuggestions]="valueForSuggestions"
            selectedItemsHideKey="label"
            (itemSelected)="handleChange($event)"
            maxlength="64"
            [ariaLabel]="filter.label"
        >
        </agpr-autocomplete>
        <span class="fa-regular fa-duotone fa-magnifying-glass agpr-filterAutocomplete-searchIcon"></span>
    </label>
</div>
